<mat-menu
  #menu="matMenu"
  xPosition="before"
  yPosition="below"
  class="pencil-mat-menu light-scheme space-visibility-menu"
>
  <app-pencil-menu-item
    *ngFor="let item of visibilityMenuItems"
    (clickEvent)="changeValue(item.value)"
    [selected]="selectedValue === item.value"
    [label]="item.title | titlecase"
    [subtitle]="item.description"
    [renderCheckIcon]="selectedValue === item.value"
    [iconConfig]="{
      type: IconTypes.img,
      alt: item.title | titlecase
    }"
    [icon]="selectedValue === item.value ? item.selectedImageSrc : item.imageSrc"
    [attr.data-name]="dataName + item.title.toLowerCase() + '-button'"
  >
  </app-pencil-menu-item>
</mat-menu>
